<div class="custom-icon-svg" [innerHTML]="renderIcon | sanitizer"></div>
